var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-tabbar',{attrs:{"route":"","route_data":_vm.footer_data}},_vm._l((_vm.footer_data),function(item){return _c('van-tabbar-item',{key:item.url,attrs:{"replace":"","to":item.url,"icon":"wap-home-o"}},[_vm._v(_vm._s(item.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }